import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-133ea04a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-start" }
const _hoisted_2 = { class: "d-flex flex-column justify-content-center h-60px" }
const _hoisted_3 = { class: "text-gray-400" }
const _hoisted_4 = { class: "text-end" }
const _hoisted_5 = { class: "d-flex flex-column justify-content-center h-60px" }
const _hoisted_6 = { class: "text-gray-400" }
const _hoisted_7 = { class: "text-end" }
const _hoisted_8 = { class: "d-flex flex-column justify-content-center h-60px" }
const _hoisted_9 = { class: "text-gray-400" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { colspan: "9" }
const _hoisted_15 = { class: "d-flex flex-column justify-content-center align-items-center h-60px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_common_product = _resolveComponent("common-product")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.ordered_items, (item, index) => {
      return (_openBlock(), _createElementBlock("tr", {
        class: "subtable_template sales-order text-start",
        key: index
      }, [
        _createVNode(_component_common_product, {
          gallery: [
        {
          id: 0,
          origin_url: item.primary_image,
        },
      ],
          brand_id: item.brand,
          brand_article_no: item.brand_article_no,
          product_identifier_id: '0',
          source_link: '',
          name: item.name,
          name_en: item.name_en,
          color: item.original_color,
          size: item.size,
          productCol: 3,
          skuCol: 2
        }, null, 8, ["gallery", "brand_id", "brand_article_no", "name", "name_en", "color", "size"]),
        _createElementVNode("td", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, _toDisplayString(_ctx.t("order.unitPrice")), 1),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.base == "￥"
              ? _ctx.$currency.currency(
                  item.base_unit_sales_order_price,
                  2,
                  ".",
                  "",
                  _ctx.base
                )
              : _ctx.$currency.currency(
                  item.base_unit_sales_order_price,
                  2,
                  ",",
                  ".",
                  _ctx.base
                )), 1)
          ])
        ]),
        _createElementVNode("td", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, _toDisplayString(_ctx.t("order.qty")), 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(item.ordered_qty), 1)
          ])
        ]),
        _createElementVNode("td", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, _toDisplayString(_ctx.t("salesOrder.grandTotalBase")), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.base == "￥"
              ? _ctx.$currency.currency(
                  Number(item.base_unit_sales_order_price) * item.ordered_qty,
                  2,
                  ".",
                  "",
                  _ctx.base
                )
              : _ctx.$currency.currency(
                  Number(item.base_unit_sales_order_price) * item.ordered_qty,
                  2,
                  ",",
                  ".",
                  _ctx.base
                )), 1)
          ])
        ]),
        _hoisted_10,
        _hoisted_11,
        _hoisted_12
      ]))
    }), 128)),
    (_ctx.formData.ordered_items.length == 0)
      ? _withDirectives((_openBlock(), _createElementBlock("tr", _hoisted_13, [
          _createElementVNode("td", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.isRequest ? "No data found" : ""), 1)
          ])
        ])), [
          [_directive_loading, _ctx.loading]
        ])
      : _createCommentVNode("", true)
  ], 64))
}